<template>
  <!--
    Aviso en vivo del minimo de unidades de la lista (hoy: PRECIO VOLUMEN).
    Solo aparece si la lista de la venta tiene minimo. Emite `change` con
    true/false para que la pantalla habilite o no el boton de guardar; el
    bloqueo real lo hace el servidor.
  -->
  <b-alert
    v-if="status.applies"
    :show="true"
    :variant="status.ok ? 'success' : 'danger'"
    class="mt-1 mb-0"
  >
    <div class="alert-body d-flex align-items-start">
      <feather-icon
        :icon="status.ok ? 'CheckCircleIcon' : 'AlertTriangleIcon'"
        size="18"
        class="mr-50 mt-25 flex-shrink-0"
      />
      <span>
        {{ status.text }}
        <template v-if="!status.ok && !isAdmin"> Solicita el cambio a administración.</template>
      </span>
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import axios from '@axios'
import { isAdmin } from '@/utils/auth'
import { unitRuleStatus } from './unitRuleStatus'

export default {
  components: { BAlert },

  props: {
    customerId: { type: [Number, String], default: null },
    priceListId: { type: [Number, String], default: null },
    units: { type: Number, default: 0 },
    // 'cotizacion' cuenta lo cubierto por stock; 'pedido' lo del pedido.
    documento: { type: String, default: 'pedido' },
    // Al editar un pedido, ese pedido no cuenta como compra de entrada.
    orderId: { type: [Number, String], default: null },
  },

  data() {
    return {
      rule: null,
      requestId: 0,
      isAdmin: isAdmin(),
    }
  },

  computed: {
    status() {
      return unitRuleStatus(this.rule, this.units, this.documento)
    },
  },

  watch: {
    customerId: 'loadRule',
    priceListId: 'loadRule',
    orderId: 'loadRule',
    'status.ok': {
      immediate: true,
      handler(ok) {
        this.$emit('change', ok)
      },
    },
  },

  created() {
    this.loadRule()
  },

  methods: {
    async loadRule() {
      // Cambiar de cliente o lista lanza varias peticiones seguidas: solo vale
      // la respuesta de la ultima, aunque otra mas vieja llegue despues.
      this.requestId += 1
      const { requestId } = this

      if (!this.customerId) {
        this.rule = null
        return
      }

      try {
        const { data } = await axios.get('price-list-unit-rule', {
          params: {
            customer_id: this.customerId,
            price_list_id: this.priceListId || undefined,
            order_id: this.orderId || undefined,
          },
        })
        if (requestId === this.requestId) this.rule = data.data
      } catch (e) {
        // Sin la regla no se avisa; el servidor igual valida al guardar.
        if (requestId === this.requestId) this.rule = null
      }
    },
  },
}
</script>
